import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { KanbanBoard } from '../components/KanbanBoard.js';
const COLUMNS = ['open', 'in_progress', 'blocked', 'done', 'cancelled'];
export function TasksPage() {
    const qc = useQueryClient();
    const { data, isLoading, error } = useQuery({
        queryKey: ['tasks'],
        queryFn: () => api('/api/tasks'),
    });
    const move = useMutation({
        mutationFn: (vars) => api(`/api/tasks/${vars.id}`, {
            method: 'PATCH',
            body: JSON.stringify({ status: vars.status }),
        }),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['tasks'] }),
    });
    return (_jsxs("div", { children: [_jsx("h1", { className: "text-2xl mb-4", children: "\u06A9\u0627\u0631\u0647\u0627" }), isLoading && _jsx("p", { children: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC\u2026" }), error && _jsxs("p", { className: "text-red-600", children: ["\u062E\u0637\u0627: ", error.message] }), data && (_jsx(KanbanBoard, { tasks: data.tasks, columns: COLUMNS, onMove: (id, s) => move.mutate({ id, status: s }) }))] }));
}
